module.exports = __webpack_public_path__ + "8dfe76a6b55b989a3de32e3d94b795ed.png";